import * as React from "react";
const SvgDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.37343 12.7107C8.69372 13.1142 9.30628 13.1142 9.62657 12.7107L12.7332 8.7974C13.1494 8.27312 12.776 7.5 12.1066 7.5L5.89338 7.5C5.22397 7.5 4.85061 8.27312 5.26681 8.79741L8.37343 12.7107Z", fill: "#A3A3A3", style: {
  fill: "#A3A3A3",
  fill: "color(display-p3 0.6375 0.6375 0.6375)",
  fillOpacity: 1
} }));
export default SvgDown;
